import _ from 'lodash'

import React, { Component } from 'react'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import { setMainAreaErrors, clearMainAreaErrors, readMainArea, updateMainArea } from '../actions/main-area'

import MainAreaEdit from '../components/MainAreaEdit'
class MainAreaEditPage extends Component {
  componentDidMount () {
    const {  readMainArea, match } = this.props
    readMainArea(match.params.id)
    clearMainAreaErrors()
  }

  render () {
    return (<MainAreaEdit {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { current } = state.mainArea
  const props = {
    errors: _.get(state, 'mainArea.errors', {})
  }
  if (current) {
    props.initialValues = { ...current }
  }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  readMainArea (id) {
    dispatch(readMainArea(id))
  },
  async onSubmit (values) {
    const errors = {}
    if (!values.name) {
      errors.name = 'Main area name is required.'
    }
    if (!_.isEmpty(errors)) {
      dispatch(setMainAreaErrors(errors))
      return
    }
    dispatch(clearMainAreaErrors())
    await dispatch(updateMainArea({
      ...values
    }))
    dispatch(push('/mainArea'))
  },
  goBack () {
    dispatch(goBack())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(MainAreaEditPage)


// WEBPACK FOOTER //
// ./src/containers/MainAreaEditPage.js